import './FreelanceMenu.scss';

import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Link, withRouter} from "react-router-dom";
import api from "../../../../../api";
import {generate} from "../../../../routes.js";

import ChevronUp from 'react-feather/dist/icons/chevron-up.js';
import ChevronDown from 'react-feather/dist/icons/chevron-down.js';

import {isUserComplete} from "../../../../../shared/services/userService";

class FreelanceMenu extends Component {
  static propTypes = {
    className: PropTypes.string,
    link: PropTypes.object,
    onMobileCtaClick: PropTypes.func,
    isMobile: PropTypes.bool,
    isAdmin: PropTypes.bool,
  };

  static defaultProps = {
    link: {
      menu: 'freelance-profile',
      parameters: {},
      search: {},
    },
    onMobileCtaClick : () => {},
    isMobile: false,
    isAdmin: false,
  };

  constructor(props) {
    super(props);
    const defaultVisibility = !props.isMobile
    this.state = {
      visibilities: {
        inscription: defaultVisibility,
        presentation: defaultVisibility,
        experiences: defaultVisibility,
        formations: defaultVisibility,
        documents: defaultVisibility,
        mySearch: defaultVisibility,
      }
    }
  }

  toggleListVisibility = (entry, event) => {
    if(event) {
      event.stopPropagation()
    }

    const {visibilities} = this.state
    visibilities[entry] = !visibilities[entry]

    this.setState({
      visibilities: {
        ...visibilities
      }})
  }

  isListVisible = (entry) => {
    const {visibilities} = this.state
    return visibilities[entry]
  }

  getListVisibilityClass = (entry) => {
    return (this.isListVisible(entry) ? 'visible' : 'hidden')
  }

  makeMenuLinkTo = (routeSuffix, hash = '') => {
    const {link} = this.props

    return generate({
      name: `${link.menu}.${routeSuffix}`,
      parameters: link.parameters,
      search: link.search,
      hash: hash
    })
  }

  refreshUser = async () => {
    const {refresh, freelance: freelanceProps} = this.props
    if(!freelanceProps) {
      return
    }
    const freelance = (await api.freelances.getOne({freelance: freelanceProps.id})).data;
    refresh({
      user: {...this.props.user, ...freelance.user},
      freelance: {...this.props.freelance, ...freelance},
    });
  }

  onLinkClick= (linkPath) => {
    const {history} = this.props
    this.refreshUser()
    history.push(linkPath)
  }

  render() {
    const {makeMenuLinkTo} = this
    const {isAdmin, user} = this.props

    return (
      <div className="freelance-menu">
        {isAdmin && (
          <Fragment>
            <div className="freelance-menu-title" onClick={(event) => this.toggleListVisibility('inscription', event)}>
              <span>Inscription</span>
              <span>{this.isListVisible('inscription') ? <ChevronDown/> : <ChevronUp/>}</span>
            </div>
            <ul className={`freelance-menu-list ${this.getListVisibilityClass('inscription')}`}>
              <li className="freelance-menu-list-item">
                <Link
                  onClick={this.props.onLinkClick}
                  to={makeMenuLinkTo('cv', "#cv")}>
                  CV
                </Link>
              </li>
              <li className="freelance-menu-list-item">
                <Link
                  to={makeMenuLinkTo('preferences')}>
                  Préférences
                </Link>
              </li>
            </ul>
            <div className="freelance-menu-separator"/>
          </Fragment>
        )}

        <div className="freelance-menu-title" onClick={(event) => this.toggleListVisibility('presentation', event)}>
          <span>Présentation du profil</span>
          <span>{this.isListVisible('presentation') ? <ChevronDown/> : <ChevronUp/>}</span>
        </div>
        <ul className={`freelance-menu-list ${this.getListVisibilityClass('presentation')}`}>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('pres', "#pres-profile-picture")}>
              Photo de profil
            </Link>
          </li>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('pres', "#pres-perso")}>
              Informations personnelles
            </Link>
          </li>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('pres', "#pres-pro")}>
              Présentation professionnelle
            </Link>
          </li>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('pres', "#pres-linkedin")}>
              Linkedin
            </Link>
          </li>
        </ul>
        <div className="freelance-menu-separator"/>

        <div className="freelance-menu-title" onClick={(event) => this.toggleListVisibility('experiences', event)}>
          <span>
            Expérience professionnelle
          </span>
          <span>{this.isListVisible('experiences') ? <ChevronDown/> : <ChevronUp/>}</span>
        </div>
        <ul className={`freelance-menu-list ${this.getListVisibilityClass('experiences')}`}>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('activities',)}>
              Secteurs
            </Link>
          </li>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('mission',)}>
              Missions
            </Link>
          </li>
        </ul>
        <div className="freelance-menu-separator"/>

        <div className="freelance-menu-title" onClick={(event) => this.toggleListVisibility('formations', event)}>
          <span>
            Formations
          </span>
          <span>{this.isListVisible('formations') ? <ChevronDown/> : <ChevronUp/>}</span>
        </div>
        <ul className={`freelance-menu-list ${this.getListVisibilityClass('formations')}`}>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('formations', "#degrees")}>
              Diplômes
            </Link>
          </li>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('formations', "#certifications")}
            >
              Certifications
            </Link>
          </li>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('formations', "#tools")}>
              Outils et logiciels
            </Link>
          </li>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('formations', "#languages")}>
              Langues
            </Link>
          </li>
        </ul>
        <div className="freelance-menu-separator"/>

        <div className="freelance-menu-title" onClick={(event) => this.toggleListVisibility('documents', event)}>
          <span>Documents</span>
          <span>{this.isListVisible('documents') ? <ChevronDown/> : <ChevronUp/>}</span>
        </div>
        <ul className={`freelance-menu-list ${this.getListVisibilityClass('documents')}`}>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('cv', "#cv")}>
              CV
            </Link>
          </li>
          <li className="freelance-menu-list-item">
            <Link
              to={makeMenuLinkTo('cv', "#skill-folder")}>
              Dossier de compétences
            </Link>
          </li>
        </ul>

        <div className="freelance-menu-separator"/>

        {(isUserComplete(user) || isAdmin) &&
          <Fragment>
            <div className="freelance-menu-title" onClick={(event) => this.toggleListVisibility('mySearch', event)}>
              <span>Ma recherche</span>
              <span>{this.isListVisible('mySearch') ? <ChevronDown/> : <ChevronUp/>}</span>
            </div>
            <ul className={`freelance-menu-list ${this.getListVisibilityClass('mySearch')}`}>
              <li className="freelance-menu-list-item">
                <span className={'link'} onClick={() => this.onLinkClick(makeMenuLinkTo('my-search', "#availibility"))}>
              Disponibilité
                </span>
              </li>
              <li className="freelance-menu-list-item">
                <span className={'link'} onClick={() => this.onLinkClick(makeMenuLinkTo('my-search', "#visibility"))}>
              Visibilité du profil
                </span>
              </li>
              <li className="freelance-menu-list-item">
                <span className={'link'} onClick={() => this.onLinkClick(makeMenuLinkTo('my-search', "#location"))}>
              Localisation
                </span>
              </li>
              <li className="freelance-menu-list-item">
                <span className={'link'} onClick={() => this.onLinkClick(makeMenuLinkTo('my-search', "#tjm"))}>
              TJM
                </span>
              </li>
              <li className="freelance-menu-list-item">
                <Link
                  to={makeMenuLinkTo('alertes')}>
                  Notifications
                </Link>
              </li>
            </ul>
          </Fragment>
        }
      </div>
    );
  }
}

export default withRouter(FreelanceMenu)
